import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export function SEOContent() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section principale SEO */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-20"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-8 leading-tight">
            Réparation de Fenêtres à Bordeaux : Expertise et Rapidité
          </h2>
          <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed space-y-6">
            <p>
              <strong>FenetrePro Bordeaux</strong> est votre spécialiste de la <strong><Link to="/bordeaux" className="text-teal hover:underline">réparation de fenêtres à Bordeaux</Link></strong> et dans toute la Gironde. Depuis 2009, nous intervenons pour tous types de dépannages : <Link to="/bordeaux" className="text-teal hover:underline">fenêtres PVC</Link>, <Link to="/bordeaux" className="text-teal hover:underline">fenêtres bois</Link>, <Link to="/bordeaux" className="text-teal hover:underline">fenêtres aluminium</Link>, <Link to="/bordeaux" className="text-teal hover:underline">baies vitrées</Link> et <Link to="/bordeaux" className="text-teal hover:underline">volets roulants</Link>. Notre équipe de techniciens qualifiés assure des interventions rapides et professionnelles pour résoudre tous vos problèmes de menuiserie.
            </p>
            <p>
              Que vous ayez besoin d'un <strong>remplacement de vitrage cassé</strong>, d'un <strong>changement de joints d'étanchéité</strong>, d'un <strong>réglage de mécanisme d'ouverture</strong> ou d'une <strong>réparation de volet roulant</strong>, nous disposons de l'expertise et du matériel nécessaires pour intervenir efficacement. Nous travaillons avec des pièces de qualité supérieure pour garantir la durabilité de nos réparations.
            </p>
          </div>
        </motion.div>

        {/* Grille de contenu SEO */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-20">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="bg-gradient-to-br from-teal/5 to-teal/10 rounded-3xl p-10"
          >
            <div className="w-16 h-16 flex items-center justify-center mb-6">
              <i className="ri-tools-line text-5xl text-teal"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-6">
              Pourquoi Choisir FenetrePro Bordeaux ?
            </h3>
            <ul className="space-y-4 text-gray-700">
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-teal text-xl mt-1 flex-shrink-0"></i>
                <span><strong>Intervention rapide</strong> : Nous intervenons sous 24h pour tous vos dépannages urgents à <Link to="/bordeaux" className="text-teal hover:underline">Bordeaux</Link> et ses environs</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-teal text-xl mt-1 flex-shrink-0"></i>
                <span><strong>Expertise reconnue</strong> : Plus de 15 ans d'expérience dans la <Link to="/bordeaux" className="text-teal hover:underline">réparation de fenêtres PVC, bois et aluminium</Link></span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-teal text-xl mt-1 flex-shrink-0"></i>
                <span><strong>Devis gratuit</strong> : Diagnostic vidéo par WhatsApp gratuit et sans engagement pour évaluer vos besoins</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-teal text-xl mt-1 flex-shrink-0"></i>
                <span><strong>Garantie qualité</strong> : Toutes nos réparations sont garanties avec des pièces de rechange certifiées</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-teal text-xl mt-1 flex-shrink-0"></i>
                <span><strong>Prix transparents</strong> : Tarifs clairs et compétitifs sans frais cachés pour tous nos services</span>
              </li>
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="bg-gradient-to-br from-orange/5 to-orange/10 rounded-3xl p-10"
          >
            <div className="w-16 h-16 flex items-center justify-center mb-6">
              <i className="ri-map-pin-line text-5xl text-orange"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-6">
              Zone d'Intervention à Bordeaux
            </h3>
            <p className="text-gray-700 mb-6 leading-relaxed">
              Nous intervenons dans toute la métropole bordelaise et les communes environnantes pour tous vos besoins en <strong>réparation de fenêtres</strong>, <strong>dépannage de volets roulants</strong> et <strong>réparation de baies vitrées</strong>.
            </p>
            <div className="grid grid-cols-2 gap-3 text-sm text-gray-700">
              <div className="flex items-center gap-2">
                <i className="ri-map-pin-2-fill text-teal text-base"></i>
                <Link to="/bordeaux" className="hover:text-teal hover:underline">Bordeaux Centre</Link>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-map-pin-2-fill text-teal text-base"></i>
                <Link to="/merignac" className="hover:text-teal hover:underline">Mérignac</Link>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-map-pin-2-fill text-teal text-base"></i>
                <Link to="/pessac" className="hover:text-teal hover:underline">Pessac</Link>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-map-pin-2-fill text-teal text-base"></i>
                <Link to="/talence" className="hover:text-teal hover:underline">Talence</Link>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-map-pin-2-fill text-teal text-base"></i>
                <Link to="/begles" className="hover:text-teal hover:underline">Bègles</Link>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-map-pin-2-fill text-teal text-base"></i>
                <Link to="/villenave-ornon" className="hover:text-teal hover:underline">Villenave-d'Ornon</Link>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-map-pin-2-fill text-teal text-base"></i>
                <Link to="/cenon" className="hover:text-teal hover:underline">Cenon</Link>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-map-pin-2-fill text-teal text-base"></i>
                <Link to="/floirac" className="hover:text-teal hover:underline">Floirac</Link>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-map-pin-2-fill text-teal text-base"></i>
                <Link to="/gradignan" className="hover:text-teal hover:underline">Gradignan</Link>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-map-pin-2-fill text-teal text-base"></i>
                <Link to="/le-bouscat" className="hover:text-teal hover:underline">Le Bouscat</Link>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-map-pin-2-fill text-teal text-base"></i>
                <Link to="/bruges" className="hover:text-teal hover:underline">Bruges</Link>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-map-pin-2-fill text-teal text-base"></i>
                <Link to="/eysines" className="hover:text-teal hover:underline">Eysines</Link>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Nouvelle section Baies Vitrées */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-20"
        >
          <div className="text-center mb-12">
            <div className="inline-block bg-teal/10 text-teal px-6 py-2 rounded-full text-sm font-semibold mb-6">
              SPÉCIALITÉ BAIES VITRÉES
            </div>
            <h3 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Réparation de Baies Vitrées<br />Toutes Marques
            </h3>
            <p className="text-lg text-gray-700 max-w-4xl mx-auto leading-relaxed">
              Experts en <strong><Link to="/bordeaux" className="text-teal hover:underline">réparation de baies vitrées</Link></strong> à Bordeaux, nous intervenons sur toutes les marques et tous les types de baies vitrées : coulissantes, à galandage, pliantes, fixes ou oscillo-battantes. Nos techniciens qualifiés réparent vos baies vitrées <strong>Technal, K-Line, Schüco, Reynaers, Kawneer, Veka</strong> et toutes autres marques avec des pièces d'origine.
            </p>
          </div>

          {/* Grille des formes de baies vitrées */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
            {[
              {
                icon: 'ri-layout-column-line',
                title: 'Baie Vitrée Coulissante',
                description: 'Réparation de rails, roulettes, joints et mécanismes de verrouillage. Remplacement de vitrage et ajustement des vantaux pour un coulissement fluide.',
                brands: 'Technal, K-Line, Schüco'
              },
              {
                icon: 'ri-layout-left-2-line',
                title: 'Baie à Galandage',
                description: 'Dépannage de systèmes à galandage encastrés dans le mur. Réparation de rails cachés, chariots et mécanismes de fermeture automatique.',
                brands: 'Reynaers, Kawneer, Veka'
              },
              {
                icon: 'ri-layout-grid-line',
                title: 'Baie Vitrée Pliante',
                description: 'Réparation de baies accordéon et pliantes. Ajustement des charnières, remplacement de joints et réparation des systèmes de pliage.',
                brands: 'Technal, Schüco, Solarlux'
              },
              {
                icon: 'ri-layout-4-line',
                title: 'Baie Vitrée Fixe',
                description: 'Remplacement de vitrage fixe cassé ou fissuré. Réparation de joints d\'étanchéité et amélioration de l\'isolation thermique et phonique.',
                brands: 'Toutes marques'
              },
              {
                icon: 'ri-door-open-line',
                title: 'Baie Oscillo-Battante',
                description: 'Réparation de mécanismes oscillo-battants. Ajustement des charnières, remplacement de crémones et réglage des systèmes d\'ouverture.',
                brands: 'K-Line, Veka, Rehau'
              },
              {
                icon: 'ri-stack-line',
                title: 'Baie Levante-Coulissante',
                description: 'Dépannage de systèmes levante-coulissante haut de gamme. Réparation de mécanismes de levage, roulettes et joints périphériques.',
                brands: 'Schüco, Reynaers, Technal'
              }
            ].map((type, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-gradient-to-br from-white to-teal/5 border-2 border-teal/20 rounded-2xl p-8 hover:border-teal hover:shadow-xl transition-all duration-300"
              >
                <div className="w-14 h-14 flex items-center justify-center mb-6">
                  <i className={`${type.icon} text-5xl text-teal`}></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-4">
                  {type.title}
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed mb-4">
                  {type.description}
                </p>
                <div className="pt-4 border-t border-teal/20">
                  <p className="text-xs text-teal font-semibold">
                    Marques : {type.brands}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>

          {/* Interventions courantes sur baies vitrées */}
          <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-3xl p-10">
            <h4 className="text-2xl font-bold text-gray-900 mb-8 text-center">
              Nos Interventions sur Baies Vitrées
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-teal/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-tools-fill text-teal text-xl"></i>
                </div>
                <div>
                  <h5 className="font-bold text-gray-900 mb-2">Remplacement de Roulettes et Rails</h5>
                  <p className="text-sm text-gray-600">Changement de roulettes usées et réparation de rails endommagés pour un coulissement optimal</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-teal/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-contrast-drop-line text-teal text-xl"></i>
                </div>
                <div>
                  <h5 className="font-bold text-gray-900 mb-2">Remplacement de Vitrage</h5>
                  <p className="text-sm text-gray-600">Changement de vitrage cassé, fissuré ou embué avec double ou triple vitrage haute performance</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-teal/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-water-percent-line text-teal text-xl"></i>
                </div>
                <div>
                  <h5 className="font-bold text-gray-900 mb-2">Changement de Joints d'Étanchéité</h5>
                  <p className="text-sm text-gray-600">Remplacement de joints usés pour éviter infiltrations d'eau et améliorer l'isolation</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-teal/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-settings-3-line text-teal text-xl"></i>
                </div>
                <div>
                  <h5 className="font-bold text-gray-900 mb-2">Réglage et Ajustement</h5>
                  <p className="text-sm text-gray-600">Ajustement précis des vantaux, réglage de la hauteur et alignement pour une fermeture parfaite</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-teal/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-door-lock-line text-teal text-xl"></i>
                </div>
                <div>
                  <h5 className="font-bold text-gray-900 mb-2">Réparation de Serrures et Poignées</h5>
                  <p className="text-sm text-gray-600">Remplacement de poignées cassées et réparation de systèmes de verrouillage multipoints</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-teal/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-temp-cold-line text-teal text-xl"></i>
                </div>
                <div>
                  <h5 className="font-bold text-gray-900 mb-2">Amélioration de l'Isolation</h5>
                  <p className="text-sm text-gray-600">Optimisation de l'isolation thermique et phonique pour réduire vos factures énergétiques</p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Section problèmes courants */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-20"
        >
          <h3 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-10 text-center">
            Problèmes Courants de Fenêtres à Bordeaux
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                icon: 'ri-contrast-drop-line',
                title: 'Vitrage Cassé ou Fissuré',
                description: 'Remplacement rapide de vitres endommagées suite à un choc, une effraction ou des conditions météorologiques. Intervention d\'urgence disponible.'
              },
              {
                icon: 'ri-water-percent-line',
                title: 'Infiltrations d\'Eau',
                description: 'Réparation des joints d\'étanchéité défectueux causant des infiltrations d\'eau et d\'humidité. Amélioration de l\'isolation de vos fenêtres.'
              },
              {
                icon: 'ri-door-lock-line',
                title: 'Problème de Fermeture',
                description: 'Réglage et réparation des mécanismes de fermeture défaillants. Fenêtres qui ne ferment plus correctement ou qui coincent.'
              },
              {
                icon: 'ri-temp-cold-line',
                title: 'Mauvaise Isolation',
                description: 'Amélioration de l\'isolation thermique et phonique. Réduction des déperditions de chaleur et des nuisances sonores extérieures.'
              },
              {
                icon: 'ri-settings-3-line',
                title: 'Mécanisme Bloqué',
                description: 'Déblocage et réparation des systèmes d\'ouverture et de fermeture. Remplacement de pièces usées ou cassées pour un fonctionnement optimal.'
              },
              {
                icon: 'ri-window-line',
                title: 'Volet Roulant en Panne',
                description: 'Dépannage de volets roulants manuels ou électriques. Remplacement de lames, de sangles, de moteurs et de télécommandes défectueuses.'
              }
            ].map((problem, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-white border-2 border-gray-100 rounded-2xl p-8 hover:border-teal hover:shadow-xl transition-all duration-300"
              >
                <div className="w-14 h-14 flex items-center justify-center mb-6">
                  <i className={`${problem.icon} text-5xl text-teal`}></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-4">
                  {problem.title}
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {problem.description}
                </p>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Section avantages réparation vs remplacement */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-[32px] p-12 lg:p-16"
        >
          <h3 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-8 text-center">
            Réparation ou Remplacement de Fenêtres ?
          </h3>
          <p className="text-lg text-gray-700 text-center mb-12 max-w-4xl mx-auto leading-relaxed">
            Dans la plupart des cas, la <strong><Link to="/bordeaux" className="text-teal hover:underline">réparation de fenêtres</Link></strong> est une solution plus économique et plus rapide que le remplacement complet. Nos experts évaluent l'état de vos fenêtres et vous conseillent la meilleure option selon votre situation.
          </p>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-12 h-12 bg-teal/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-tools-fill text-teal text-2xl"></i>
                </div>
                <h4 className="text-2xl font-bold text-gray-900">Avantages de la Réparation</h4>
              </div>
              <ul className="space-y-4 text-gray-700">
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-teal text-xl mt-1 flex-shrink-0"></i>
                  <span><strong>Économique</strong> : Coût 3 à 5 fois moins élevé qu'un remplacement complet de fenêtre</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-teal text-xl mt-1 flex-shrink-0"></i>
                  <span><strong>Rapide</strong> : Intervention en quelques heures sans travaux lourds ni démontage complet</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-teal text-xl mt-1 flex-shrink-0"></i>
                  <span><strong>Écologique</strong> : Prolonge la durée de vie de vos fenêtres et réduit les déchets</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-teal text-xl mt-1 flex-shrink-0"></i>
                  <span><strong>Sans gros travaux</strong> : Pas de dégradation des murs, peintures ou revêtements</span>
                </li>
              </ul>
            </div>
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-12 h-12 bg-orange/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-refresh-line text-orange text-2xl"></i>
                </div>
                <h4 className="text-2xl font-bold text-gray-900">Quand Remplacer ?</h4>
              </div>
              <ul className="space-y-4 text-gray-700">
                <li className="flex items-start gap-3">
                  <i className="ri-arrow-right-s-line text-orange text-xl mt-1 flex-shrink-0"></i>
                  <span>Fenêtres très anciennes avec simple vitrage nécessitant une mise aux normes</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-arrow-right-s-line text-orange text-xl mt-1 flex-shrink-0"></i>
                  <span>Cadres de fenêtres fortement endommagés ou pourris (bois) au-delà de toute réparation</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-arrow-right-s-line text-orange text-xl mt-1 flex-shrink-0"></i>
                  <span>Changement de style architectural ou rénovation complète de votre habitation</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-arrow-right-s-line text-orange text-xl mt-1 flex-shrink-0"></i>
                  <span>Amélioration importante de la performance énergétique pour réduire vos factures</span>
                </li>
              </ul>
            </div>
          </div>
        </motion.div>

        {/* Section conseils d'entretien */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mt-20"
        >
          <h3 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-10 text-center">
            Conseils d'Entretien pour Vos Fenêtres
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white border-2 border-teal/20 rounded-2xl p-8">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-12 h-12 bg-teal/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-calendar-check-line text-teal text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900">Entretien Régulier</h4>
              </div>
              <ul className="space-y-3 text-gray-700 text-sm">
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-teal text-base mt-1 flex-shrink-0"></i>
                  <span>Nettoyez vos fenêtres 2 fois par an avec des produits adaptés à chaque matériau</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-teal text-base mt-1 flex-shrink-0"></i>
                  <span>Lubrifiez les mécanismes d'ouverture et les charnières tous les 6 mois</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-teal text-base mt-1 flex-shrink-0"></i>
                  <span>Vérifiez l'état des joints d'étanchéité et remplacez-les si nécessaire</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-teal text-base mt-1 flex-shrink-0"></i>
                  <span>Contrôlez le bon fonctionnement des systèmes de fermeture et de verrouillage</span>
                </li>
              </ul>
            </div>
            <div className="bg-white border-2 border-orange/20 rounded-2xl p-8">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-12 h-12 bg-orange/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-alert-line text-orange text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900">Signes d'Alerte</h4>
              </div>
              <ul className="space-y-3 text-gray-700 text-sm">
                <li className="flex items-start gap-2">
                  <i className="ri-error-warning-fill text-orange text-base mt-1 flex-shrink-0"></i>
                  <span>Condensation excessive entre les vitres indiquant un problème d'étanchéité</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-error-warning-fill text-orange text-base mt-1 flex-shrink-0"></i>
                  <span>Difficulté à ouvrir ou fermer vos fenêtres nécessitant un réglage</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-error-warning-fill text-orange text-base mt-1 flex-shrink-0"></i>
                  <span>Courants d'air ressentis même fenêtres fermées signalant des joints usés</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-error-warning-fill text-orange text-base mt-1 flex-shrink-0"></i>
                  <span>Bruits anormaux lors de la manipulation indiquant une usure des mécanismes</span>
                </li>
              </ul>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}